import { render, staticRenderFns } from "./partner-service.vue?vue&type=template&id=1b887b6c"
import script from "./partner-service.vue?vue&type=script&lang=js"
export * from "./partner-service.vue?vue&type=script&lang=js"
import style0 from "./partner-service.vue?vue&type=style&index=0&id=1b887b6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports